module.exports = __webpack_public_path__ + "static/media/slide-3.e8910f63.jpg";